import { createAction } from '@reduxjs/toolkit';
import type { ParticipantLinesMove, ParticipantMerge } from '../utils/participantLinesMoved';
import type { ParticipantRoleChange } from '../utils/participantRoleChange';

/**
 * Room-wide relabels, applied by the conversation, landmine and competitor
 * slices alike (one action, several reducers).
 */

/** `participant_lines_moved`: lines AWS put under the wrong voice, and the cards they raised, move to `into`. */
export const participantLinesMoved = createAction<ParticipantLinesMove>('participants/linesMoved');

/** `participant_reclassified` in merge shape: `from`'s lines fold into `into`. */
export const participantMerged = createAction<ParticipantMerge>('participants/merged');

/**
 * A human decided who one participant is (`participant_reclassified` in place,
 * or the bot owner's own roster confirm): their lines, concern cards and alerts
 * follow (utils/participantRoleChange R2). Dispatch it only through
 * `applyParticipantRoleChange` or for this app's own confirm: the alert slices
 * cannot tell an older decision from a newer one.
 */
export const participantReclassified = createAction<ParticipantRoleChange>('participants/reclassified');
